// #tag: SEARCH SOUND EFFECTS HOOK
// #purpose: Triggers subtle auditory confirmations when search results populate or search queries are submitted.
import { useEffect, useRef } from 'react';
import { useUiSound } from './useUiSound';

export function useSearchSounds(query: string, resultCount: number) {
  const { play } = useUiSound();
  const prevCount = useRef(0);
  const prevQuery = useRef('');

  useEffect(() => {
    const trimmed = query.trim();
    if (trimmed && resultCount > 0 && prevCount.current === 0 && prevQuery.current !== trimmed) {
      play('resultFound');
    }
    prevCount.current = resultCount;
    prevQuery.current = trimmed;
  }, [query, resultCount, play]);

  const onSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && query.trim()) {
      play('search');
    }
  };

  return { onSearchKeyDown };
}
